import React from 'react'
import { useOutletContext } from "react-router-dom";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress } from '@mui/material';


const ClassementDetail = () => {

    const {liveClassement} = useOutletContext();

    if(!liveClassement)
        return <CircularProgress />

    return <Box>
        <Typography sx={{fontSize : '1.6em', fontWeight : 'bold', textTransform : 'uppercase'}}>TABLEAU DES MéDAILLES</Typography>
        <Box sx={{display : 'flex', alignItems : 'center', flexDirection : 'column', mt : 5}}>
            <MedalTable classement={liveClassement} />
        </Box>
        
    </Box>
};

const MedalTable = ({ classement }) => {

    classement?.entries?.sort((a, b) => getMedalCount(b.gameFacts, 'gold') - getMedalCount(a.gameFacts, 'gold'))

   if (!classement?.entries) {
      return <CircularProgress/>
    }

    return (
      classement && <TableContainer sx={{maxWidth : 700 }} component={Paper} elevation={4} >
        <Table sx={{ minWidth: 650 }} aria-label="medal table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell align="center">Or</TableCell>
              <TableCell align="center">Argent</TableCell>
              <TableCell align="center">Bronze</TableCell>
              <TableCell align="center">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {classement?.entries?.map((entry, index) => (
              <TableRow
                key={entry.label}
                sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' }, fontWeight : entry.label === 'France' ? 'bold' : 'normal' }}
              >
                <TableCell sx={{fontWeight : entry.label === 'France' ? 'bold' : 'normal' }} component="th" scope="row">{index + 1}</TableCell>
                <TableCell sx={{textTransform : 'uppercase', fontWeight : entry.label === 'France' ? 'bold' : 'normal' }}>{entry.label}</TableCell>
                <TableCell sx={{fontWeight : entry.label === 'France' ? 'bold' : 'normal' }} align="center">{getMedalCount(entry.gameFacts, 'gold')}</TableCell>
                <TableCell sx={{fontWeight : entry.label === 'France' ? 'bold' : 'normal' }} align="center">{getMedalCount(entry.gameFacts, 'silver')}</TableCell>
                <TableCell sx={{fontWeight : entry.label === 'France' ? 'bold' : 'normal' }} align="center">{getMedalCount(entry.gameFacts, 'bronze')}</TableCell>
                <TableCell sx={{fontWeight : entry.label === 'France' ? 'bold' : 'normal' }} align="center">{getTotalMedals(entry.gameFacts)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  
  // Fonction pour récupérer le nombre de médailles par type
  const getMedalCount = (gameFacts, medalType) => {
    const fact = gameFacts.find(fact => fact.value === medalType);
    return fact ? fact.count : 0;
  };
  
  // Fonction pour calculer le total de médailles
  const getTotalMedals = (gameFacts) => {
    return gameFacts.reduce((acc, fact) => acc + fact.count, 0);
  };

export default ClassementDetail